var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import utils from "../utils";
import { BehaviorType, CollectorId, PlasmState, } from "./index";
import { FAILED_SEND_BEHAVIOR_DELAY } from "../utils/variables";
import { Sentry } from "../utils/Sentry";
class Behavior {
    constructor(plasm, appName, addMetadata) {
        this.iframeBehaviorListeners = [];
        this.plasm = plasm;
        this.appName = appName;
        this.addMetadata = addMetadata;
        this.handler = (e) => this.addLog(e, this.id);
    }
    captureScreenshot(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const screenshotsCollector = this.plasm.configuredCollectors.find((collector) => collector.id === CollectorId.screen);
            if (screenshotsCollector == null) {
                return;
            }
            yield this.plasm.createScreenshot(data);
        });
    }
    start() {
        window.addEventListener(this.id, this.handler);
        this.plasm.debug(`Behavior ${this.id} started`);
    }
    stop() {
        window.removeEventListener(this.id, this.handler);
        this.plasm.debug(`Behavior ${this.id} stopped`);
    }
    attachToDocument(doc) { }
    detachFromDocument(doc) { }
    shouldAddIsTrustedMeta(eventId) {
        const excludedEvents = [
            BehaviorType.offline,
            BehaviorType.online,
            BehaviorType.load,
            BehaviorType.beforeunload,
            BehaviorType.unfocus,
            BehaviorType.mousespeed,
            BehaviorType.keystrokespeed,
            BehaviorType.question_shown,
        ];
        return !excludedEvents.includes(eventId);
    }
    static mergeMetadata(meta, extraMetadata) {
        const base = meta !== null && meta !== void 0 ? meta : {};
        const merged = Object.assign(Object.assign({}, base), extraMetadata);
        if (base.extraData != null || extraMetadata.extraData != null) {
            merged.extraData = Object.assign(Object.assign({}, base.extraData), extraMetadata.extraData);
        }
        return merged;
    }
    addLog(event, eventId, extraMetadata, clientTime) {
        const logData = {
            app: this.appName,
            event: eventId,
            clientTime: clientTime !== null && clientTime !== void 0 ? clientTime : new Date().toISOString(),
            sessionId: this.plasm.sessionUuid,
        };
        if (this.addMetadata != null) {
            logData.meta = this.addMetadata(event);
        }
        if (extraMetadata != null) {
            logData.meta = Behavior.mergeMetadata(logData.meta, extraMetadata);
        }
        if (this.shouldAddIsTrustedMeta(eventId)) {
            logData.meta = Object.assign(Object.assign({}, logData.meta), { isTrusted: event.isTrusted });
        }
        this.plasm.behaviorData.push(logData);
        if (this.plasm.behaviorData.length === 1) {
            this.sendLog();
        }
    }
    retrySendLog() {
        return __awaiter(this, void 0, void 0, function* () {
            const { state } = this.plasm;
            if (state !== PlasmState.started) {
                this.plasm.behaviorData = [];
                return;
            }
            yield new Promise((resolve) => {
                setTimeout(() => {
                    resolve(undefined);
                }, FAILED_SEND_BEHAVIOR_DELAY);
            });
            this.sendLog();
        });
    }
    sendLog() {
        return __awaiter(this, void 0, void 0, function* () {
            const { state, options } = this.plasm;
            const { plasmApiUrl } = options;
            if (state !== PlasmState.started) {
                this.plasm.behaviorData = [];
                return;
            }
            const url = `${plasmApiUrl}/events`;
            const logData = Object.assign(Object.assign({}, this.plasm.behaviorData[0]), { sendTime: new Date().toISOString() });
            try {
                yield utils.request({
                    url,
                    method: "POST",
                    authToken: "",
                    payload: logData,
                });
                this.plasm.debug(`Log behavior ${logData.event} success`);
                this.plasm.behaviorData.shift();
                if (this.plasm.behaviorData.length > 0) {
                    this.sendLog();
                }
            }
            catch (err) {
                this.plasm.debug(`Log behavior ${logData.event} failed`);
                Sentry.captureError(err, logData);
                this.retrySendLog();
            }
        });
    }
}
export default Behavior;
